import Calendar from './Calendar';

export default Calendar;


//////////////////
// WEBPACK FOOTER
// ../~/rc-calendar/es/index.js
// module id = 584
// module chunks = 0